import { useNavigate, useParams } from 'react-router-dom'
import { useResetTradeBuilder } from 'state/store'

import {
  FullWidthBar,
  LeftSideBar,
  Navigation,
  Space,
  Typography,
  UserMenuTopBar
} from '../../components/core-v2'
import Icon from '../../components/core-v2/atoms/Icon'
import LinkIcon from '../../components/core-v2/molecules/linkIcon'
import { PATH } from '../../const'
import { useUser } from '../../utilities/hooks/useUser'
import { useAppSelector } from '../tradebuilder-v2/store/hooks'
import { getUserDisplayInfo } from '../tradebuilder-v2/util/user'
import TradeEditorTabs from './modules/00-builder/TradeEditorTabs'

function Header() {
  const builderState = useAppSelector(state => state.builder)
  const navigate = useNavigate()

  return (
    <FullWidthBar>
      <Typography className="mr-4" variant="sh3">
        Editing {builderState.selectedAccount?.accountName}
      </Typography>
      <LinkIcon
        data-testid="back-to-new-trades-button"
        disabled={false}
        icon={<Icon name="chevronLeft" size="small" />}
        iconPosition="left"
        text="Go back to the trade list"
        onClick={() => navigate(PATH.reportsTrades)}
      />
    </FullWidthBar>
  )
}

export function TradeEditorLayout() {
  const { accountId } = useParams()
  const { data: user } = useUser()
  const userInfo = getUserDisplayInfo(user)
  useResetTradeBuilder()

  return (
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={
        <>
          <Header />
          <Space mt={4}>
            {accountId && <TradeEditorTabs accountId={accountId} userInfo={userInfo} />}
          </Space>
        </>
      }
      topBarElement={<UserMenuTopBar />}
    />
  )
}
